import DynamicCrudPage from '../../../components/DynamicCrudPage';
import {
  useRevenueCalculationRules,
  useCompanies,
  useJobTypes,
  usePricingMethods,
} from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

// Ciro kanalı artık statik enum (YAZIM/ONAY_SONRASI/SATIS), ücret kaynağı da
// statik enum (MONTHLY_UNIT_FEE/QUARTERLY_TOTAL_FEE) — bu yüzden formda sadece
// şirket-bağımlı 3 dropdown (jobType / pricingMethod / company) override edilir.
const RevenueCalculationRulesPage = () => {
  const customFormFields = (fields, additionalData, isRootUser) => {
    const filteredFields = fields.filter((f) =>
      f.name === 'companyId' ? isRootUser : true
    );

    return filteredFields.map((f) => {
      if (f.name === 'companyId') {
        const companies = additionalData.companies?.companies || [];
        return {
          ...f,
          options: companies.map((c) => ({ value: c.id, label: c.name })),
        };
      }
      if (f.name === 'job_type_id') {
        const jobTypes = additionalData.jobTypes?.jobTypes || [];
        return {
          ...f,
          options: (formData) => {
            const activeOnly = jobTypes.filter((j) => j.status === 'active' || j.status === true);
            const list = (isRootUser && formData?.companyId)
              ? activeOnly.filter((j) => j.companyId === parseInt(formData.companyId) || j.company_id === parseInt(formData.companyId))
              : activeOnly;
            return list.map((j) => ({ value: j.id, label: j.name }));
          },
        };
      }
      if (f.name === 'pricing_method_ids') {
        const pricingMethods = additionalData.pricingMethods?.pricingMethods || [];
        return {
          ...f,
          options: (formData) => {
            const activeOnly = pricingMethods.filter((p) => p.status === 'active' || p.status === true);
            const list = (isRootUser && formData?.companyId)
              ? activeOnly.filter((p) => p.companyId === parseInt(formData.companyId) || p.company_id === parseInt(formData.companyId))
              : activeOnly;
            return list.map((p) => ({ value: p.id, label: p.name }));
          },
        };
      }
      return f;
    });
  };

  return (
    <DynamicCrudPage
      entityType="revenueCalculationRules"
      hook={useRevenueCalculationRules}
      additionalHooks={{
        companies: useCompanies,
        jobTypes: useJobTypes,
        pricingMethods: usePricingMethods,
      }}
      customFormFields={customFormFields}
      addButtonTextKey="revenueCalculationRules.table.addButton"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="revenueCalculationRules"
    />
  );
};

export default RevenueCalculationRulesPage;
